import { useMemo } from 'react';
import { addMediaSideBarActions } from '@wix/bi-logger-media-data/v2';

import { bi } from '../../../services/loggers/bi';
import { AddMediaSideBarActionsTarget } from '../../hoc/bi/withTrackAddMediaSideBarActionsAnalytics/withAddMediaSideBarActionsAnalytics.types';

export const useTrackAddMediaSideBarActionsAnalytics = () =>
  useMemo(
    () => ({
      trackAddMediaSideBarActionOpened: () =>
        bi.logger().report(addMediaSideBarActions({ target: AddMediaSideBarActionsTarget.Opened })),
      trackAddMediaSideBarActionClosed: () =>
        bi.logger().report(addMediaSideBarActions({ target: AddMediaSideBarActionsTarget.Closed })),
      trackAddMediaSideBarActionCancelAll: () =>
        bi.logger().report(addMediaSideBarActions({ target: AddMediaSideBarActionsTarget.CancelAll })),
      trackAddMediaSideBarActionRetryList: () =>
        bi.logger().report(addMediaSideBarActions({ target: AddMediaSideBarActionsTarget.RetryList })),
      trackAddMediaSideBarActionRetry: () =>
        bi.logger().report(addMediaSideBarActions({ target: AddMediaSideBarActionsTarget.Retry })),
      trackAddMediaSideBarActionResume: () =>
        bi.logger().report(addMediaSideBarActions({ target: AddMediaSideBarActionsTarget.Resume })),
      trackAddMediaSideBarActionClearList: () =>
        bi.logger().report(addMediaSideBarActions({ target: AddMediaSideBarActionsTarget.ClearList })),
      trackAddMediaSideBarActionForceClearList: () =>
        bi.logger().report(addMediaSideBarActions({ target: AddMediaSideBarActionsTarget.ForceClearList })),
      trackAddMediaSideBarActionClear: () =>
        bi.logger().report(addMediaSideBarActions({ target: AddMediaSideBarActionsTarget.Clear })),
      trackAddMediaSideBarActionGoToFile: () =>
        bi.logger().report(addMediaSideBarActions({ target: AddMediaSideBarActionsTarget.GoToFile })),
      trackAddMediaSideBarActionEditTags: () =>
        bi.logger().report(addMediaSideBarActions({ target: AddMediaSideBarActionsTarget.EditTags })),
    }),
    [],
  );
